
import { computed, defineComponent, onMounted, reactive } from 'vue'

import Loader from '@/common/components/UI/Loader/index.vue'
import NewButton from '@/ui-kit/NewButton/index.vue'
import PreTripStatus from '@/modules/TMSModule/components/PreTripStatus/index.vue'
import PreTripDetailsTtn from '@/modules/TMSModule/components/PreTripDetailsTtn/index.vue'
import RescheduleHistoryItem from '@/modules/TMSModule/components/PreTripDetailsRescheduleHistoryItem/index.vue'

import type { PreTripDetails, PreTripDetailsRescheduleHistoryItem } from '@/core/types/tms-graph.types'

import { tmsGraph } from '@/core/realisations/tms-graph.realisation'

export default defineComponent({
    components: {
        Loader,
        PreTripStatus,
        PreTripDetailsTtn,
        RescheduleHistoryItem,
        NewButton,
    },
    props: {
        id: {
            type: Number,
            required: true,
        },
        isCanTransfer: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['transfer', 'update-comment'],
    setup(props, { emit }) {
        const state = reactive({
            is_loading: false,
            is_failed: false,
            details: null as PreTripDetails | null,
        })

        const loadDetails = async () => {
            try {
                state.is_loading = true

                const response = await tmsGraph.getPreTripDetails(props.id)
                state.details = response.data

                state.is_failed = false
            } catch (error) {
                console.error(error)
                state.is_failed = true
            } finally {
                state.is_loading = false
            }
        }

        const onTransfer = () => {
            emit('transfer', { id: props.id })
        }

        const onUpdateComment = (item: PreTripDetailsRescheduleHistoryItem) => {
            emit('update-comment', item)
        }

        onMounted(loadDetails)

        function formatDate(inputDate: string): string {
            const [year, month, day] = inputDate.split('-')

            if (!year || !month || !day) {
                throw new Error('Invalid date format. Expected format: YYYY-MM-DD')
            }

            return `${day}.${month}.${year}`
        }

        const isProdVersion = computed(() => window.location.href.includes('bpms.spark.kz'))

        return {
            state,
            formatDate,
            onTransfer,
            onUpdateComment,
            isProdVersion,
        }
    },
})
